import type {
  CampaignDetailModelState,
  ContractAdminModel,
} from '@urbanx/agx.campaigns.client'
import {
  AustralianState,
  NswContractStage,
  QldContractStage,
} from '@urbanx/agx-ui-components'

type CampaignState = CampaignDetailModelState | AustralianState

const ValidQldStages: readonly QldContractStage[] = [
  QldContractStage.Accepted,
  QldContractStage.Unconditional,
  QldContractStage.Terminated,
  QldContractStage.Settled,
  QldContractStage.BackUp,
  QldContractStage.PendingCompliance,
]

const ValidNswStages: readonly NswContractStage[] = [
  NswContractStage.PendingCompliance,
  NswContractStage.Accepted,
  NswContractStage.Unconditional,
  NswContractStage.Settled,
]

export function filterContractsForCampaignState(
  contracts: ContractAdminModel[],
  campaignState?: CampaignState
): ContractAdminModel[] {
  if (campaignState === AustralianState.NSW)
    return contracts.filter((contract) =>
      ValidNswStages.includes(contract.stage as NswContractStage)
    )

  if (campaignState === AustralianState.QLD)
    return contracts.filter((contract) =>
      ValidQldStages.includes(contract.stage as QldContractStage)
    )

  return []
}
